import {
	servicePageConstants, preAppConstants
} from 'store';

var initialState = {
	loading: false,
	error: null,
}

export function servicePage(state = initialState, action) {
	switch (action.type) {
		case preAppConstants.RESET_APPLICATION_STATE:
			return {
				...initialState,
			};
		case servicePageConstants.SEND_SERVICE_PAGE_REQUEST:
			return {
				...state,
				loading: true,
			};
		case servicePageConstants.SEND_SERVICE_PAGE_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case servicePageConstants.SEND_SERVICE_PAGE_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		default:
			return state
	}
}